import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateReportPayload, ReportStatus } from "../api/models/report.models";
import { createReport } from "../api/report.api";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useNavigate } from "react-router-dom";

const useCreateZeroReport = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [bearerToken, companyId, toast] = useUIStore(
    useShallow((state: UIState) => [
      state.bearerToken,
      state.companyId,
      state.toastRef,
    ])
  );

  const createNewReport = async (payload: CreateReportPayload) => {
    const result = await createNewReportMutation.mutateAsync(payload);

    return result;
  };

  const createNewReportMutation = useMutation({
    mutationFn: (payload: CreateReportPayload) =>
      createReport(
        companyId as number,
        {
          ...payload,
          reportStatus: ReportStatus.Sent,
          rows: [],
        },
        bearerToken
      ),
    onError: (error) => {
      console.error("Failed to create report row:", error);
      toast?.current?.show({
        severity: "error",
        summary: t("header-row-error"),
        detail: t("text-failed-to-create-new-report"),
        life: 3000,
      });
    },
    onSuccess: (result) => {
      queryClient.invalidateQueries({
        queryKey: ["reports"],
      });
      navigate(`/reporting?showSentReports=true`);
    },
  });

  const isCreatingReport = createNewReportMutation.isPending;

  return { createNewReport, isCreatingReport };
};
export default useCreateZeroReport;
